import { render, staticRenderFns } from "./NicknameTextField.vue?vue&type=template&id=0527dc59&scoped=true&"
import script from "./NicknameTextField.vue?vue&type=script&lang=js&"
export * from "./NicknameTextField.vue?vue&type=script&lang=js&"
import style0 from "./NicknameTextField.vue?vue&type=style&index=0&id=0527dc59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527dc59",
  null
  
)

export default component.exports